import { render, staticRenderFns } from "./emoji-panel.vue?vue&type=template&id=67b621ee&"
import script from "./emoji-panel.js?vue&type=script&lang=js&"
export * from "./emoji-panel.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports